// @codekit-append "lib/_jquery-3.4.1.min.js"
// @codekit-append "lib/_io_polyfill.js"
// @codekit-append "lib/_jquery.marquee.min.js"
// @codekit-append "lib/_jquery.easing.1.3.js"
// @codekit-append "lib/_svgxuse.js"
// @codekit-append "_init.js"
// @codekit-append "_marquee.js"
// @codekit-append "_load.js"
// @codekit-append "index/_top10.js"
// @codekit-append "index/_sp_slideshow.js"
// @codekit-append "index/_topics_slideshow.js"
// @codekit-append "_common.js"